import type { WebSearchTrace } from "@shaarp/common";

/**
 * The search trace of a stored tool call, or `null` for any other tool and for
 * a call stored before the trace existed.
 */
export const readSearchTrace = (output: unknown): WebSearchTrace | null => {
  if (!output || typeof output !== "object") return null;
  const trace = (output as { searchTrace?: Partial<WebSearchTrace> })
    .searchTrace;
  return trace && Array.isArray(trace.queries)
    ? (trace as WebSearchTrace)
    : null;
};

/**
 * Whether a stored search was turned away by the answer's search budget —
 * queries skipped by a limit, not by a failure.
 */
export const isSearchBudgetSpent = (output: unknown): boolean =>
  !!output &&
  typeof output === "object" &&
  (output as { budgetSpent?: unknown }).budgetSpent === true;
